import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

toast.configure();

export const add = (data, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.postFormData(
      `${apiUrl}${PORT}/users`,
      data,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        if (response.errors.msg === "EMAIL_ALREADY_EXISTS")
          toast.error("This email id already exist", toasterConfig);
        else if (response.errors.msg === "NOT_ELIGIBILTY_TO_ADD")
          toast.error(
            `You are not allow to add more operator. Please upgrade your plan`,
            toasterConfig
          );
        else toast.error(response.errors.msg, toasterConfig);
        return callback();
      } else if (response) {
        toast.dismiss();
        toast.success("User has been added successfully", toasterConfig);
        toast.success("Email has been sent successfully", toasterConfig);
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

/**
 * @description function use for to get users/operator
 * @param {*} params accepting object
 */
export const get = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/users`, params, token)
      .then((response) => {
        if (response && !response.errors) {
          dispatch({ type: "OPERATOR_LIST", data: response });
          callback && callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
          callback && callback(false);
        } else {
          toast.error(response.errors.msg, toasterConfig);
          callback && callback(false);
        }
      })
      .catch((e) => console.log(e, "error"));
  };
};

/**
 * @description function use for to change operator Status
 * @param {*} params accepting object
 */
export const changeStatus = (data, id, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.put(
      `${apiUrl}${PORT}/users/changeStatus/${id}`,
      data,
      token,
      dispatch
    ).then((response) => {
      if (response.errors) {
        toast.error(response.errors.msg, toasterConfig);
        return callback();
      } else if (response) {
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

/**
 * @description function use for to update users
 * @param {*} params accepting object
 */
export const update = (data, id, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const {
      user: { token },
    } = getState();
    ApiClient.putFormData(
      `${apiUrl}${PORT}/users/${id}`,
      data,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        if (response.errors.msg === "EMAIL_ALREADY_EXISTS")
          toast.error("Email Already exists", toasterConfig);
        else if (response.errors.msg === "ADMIN_DOES_NOT_EXIST")
          toast.error("Please Select Admin for atleast one user", toasterConfig);
        else toast.error(response.errors.msg, toasterConfig);
        return callback();
      } else if (response) {
        toast.dismiss();
        toast.success("User has been updated successfully", toasterConfig);
        return callback(response);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};

export const getUser = (id, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.get(`${apiUrl}${PORT}/users/${id}`, {}, token, dispatch).then(
      (response) => {
        dispatch({ type: "ISLOADING", data: false });
        // response = JSON.parse(response);
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};

/**
 * @description function use for to resend Email
 * @param {*} params accepting object
 */
export const resendEmail = (id, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    dispatch({ type: "ISLOADING", data: true });
    ApiClient.post(
      `${apiUrl}${PORT}/users/resendSetupMail/${id}`,
      {},
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response.errors) {
        toast.error(response.errors.msg, toasterConfig);
        return callback(false);
      } else if (response) {
        return callback(true);
      } else {
        toast.error(response.message);
        return callback();
      }
    });
  };
};
